import React, { useEffect } from "react";
import MasterCard from "../../../assets/images/ic_mastercard.svg";
import Visa from "../../../assets/images/ic_visa.svg";
import Mada from "../../../assets/images/ic_mada.svg";
import Amex from "../../../assets/images/ic_amex.svg";
import STC from "../../../assets/images/ic_STC-pay.svg";
import { injectIntl } from "react-intl";
import "./Payment.scss";
export const Payment = injectIntl((props) => {
  const { messages } = props.intl;
  return (
    <section className="wrapper container payment-methods">
        <div className="title mb-3 mb-md-5">
          <h2 className="text-center text-uppercase bold_font m-0">{messages.paymentMethods[0]}</h2>
          <h2 className="text-center text-uppercase bold_font m-0">{messages.paymentMethods[1]}</h2>
        </div>
        <div className="pricing-logos d-flex justify-content-center p-xs-0">
          <div className="image-wrapper mx-2">
            <img
              src={MasterCard}
              data-aos="zoom-in"
              data-aos-delay="200"
              alt="img-paid"
            />
          </div>
          <div className="image-wrapper mx-2">
            <img
              src={Visa}
              data-aos="zoom-in"
              data-aos-delay="800"
              alt="img-paid"
            />
          </div>
          <div className="image-wrapper mx-2">
            <img
              src={Mada}
              data-aos="zoom-in"
              data-aos-delay="1200"
              alt="img-paid"
            />
          </div>
          <div className="image-wrapper mx-2">
            <img
              src={STC}
              data-aos="zoom-in"
              data-aos-delay="1700"
              alt="img-paid"
            />
          </div>
          <div className="image-wrapper mx-2">
            <img
              src={Amex}
              data-aos="zoom-in"
              data-aos-delay="2200"
              alt="img-paid"
            />
          </div>
        </div>
    </section>
  );
});
